import { IPersonalDetails } from 'src/common-types/index';

export const updatePersonalInfo = (
  infoObject: IPersonalDetails,
  value: { [key: string]: string | number | boolean },
): IPersonalDetails => {
  const newInfo = {
    ...infoObject,
    ...value,
  };
  return newInfo;
};
